import { Table } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import usePagination from 'modules/core/hooks/usePagination'

import EmptyFolders from 'modules/documents/components/Settings/FoldersTable/EmptyFolders'
import FolderItem from 'modules/documents/components/Settings/FoldersTable/FolderItem'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'

import ReadOnlyFolder from './ReadOnlyFolder'

interface Props {
  folders: Folder[]
  space: (typeof SPACES)[keyof typeof SPACES]
  currentFolder?: Folder
  openCreateModal: () => void
}

const FoldersTable = ({ folders, space, currentFolder, openCreateModal }: Props) => {
  const { navigation } = useNavigation()

  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: folders,
  })

  if (currentFolder?.showOnly) {
    return <ReadOnlyFolder />
  }

  if (paginatedItems.length == 0) {
    return <EmptyFolders folder={currentFolder} openCreateModal={openCreateModal} />
  }

  const folderDetailsUrl = (id: number) => {
    switch (space) {
      case SPACES.COMPANY_INTERNAL:
        return navigation.settings.folders.internal.show.fullPath({ id })
      case SPACES.COMPANY_PUBLIC:
        return navigation.settings.folders.public.show.fullPath({ id })
      default:
        return navigation.settings.folders.employees.show.fullPath({ id })
    }
  }

  return (
    <Table fullWidth bottomSticky>
      <Table.BodyWithInfiniteScroll page={page} loadMore={loadMore} hasMore={hasMore} colSpan={5}>
        {paginatedItems.map((folder) => (
          <FolderItem folder={folder} key={folder.id} url={folderDetailsUrl(folder.id)} />
        ))}
      </Table.BodyWithInfiniteScroll>
    </Table>
  )
}
export default FoldersTable
